import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import * as LucideIcons from 'lucide-react';
import { highlightMatch } from '../../../hooks/useGlobalSearch';

function resolveIcon(name) {
  if (!name) return LucideIcons.Square;
  return LucideIcons[name] || LucideIcons.Square;
}

function HighlightedText({ text, query }) {
  const parts = useMemo(() => highlightMatch(text, query), [text, query]);
  return (
    <>
      {parts.map((p, i) =>
        p.kind === 'mark' ? (
          <mark key={i} className="kp-search-mark">{p.value}</mark>
        ) : (
          <React.Fragment key={i}>{p.value}</React.Fragment>
        ),
      )}
    </>
  );
}

function MatchReason({ reason }) {
  if (!reason) return null;
  if (reason.type === 'tag') {
    return <span className="kp-search-item-meta">matchar: {reason.text}</span>;
  }
  if (reason.type === 'synonym') {
    return <span className="kp-search-item-meta">relaterad: {reason.text}</span>;
  }
  return null;
}

export function SearchResultItem({ result, query, onSelect }) {
  const { module: mod, matchReason } = result;
  const Icon = useMemo(() => resolveIcon(mod.iconName), [mod.iconName]);
  return (
    <Link
      to={mod.to}
      className="kp-search-item"
      onClick={onSelect}
    >
      <span className="kp-search-item-icon">
        <Icon size={14} strokeWidth={2} aria-hidden="true" />
      </span>
      <span className="kp-search-item-body">
        <span className="kp-search-item-label">
          <HighlightedText text={mod.label} query={query} />
        </span>
        <MatchReason reason={matchReason} />
      </span>
    </Link>
  );
}
